module.exports = __webpack_public_path__ + "static/media/nandana_event.bcb311c6.jpeg";